(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero-fullscreen"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.body.classList.add('has-hero-fullscreen');

    var hero, media, overlay, zones;
    var transitionEl, transitionVideoDesktop, transitionVideoMobile;
    var currentScale = 1.2;
    var mq = window.matchMedia('(prefers-reduced-motion: no-preference)');
    var mqMobile = window.matchMedia('(max-width: 749px)');

    function getActiveMediaWrap() {
      if (!hero) return null;
      return mqMobile.matches
        ? hero.querySelector('.hero-fullscreen__media--mobile')
        : hero.querySelector('.hero-fullscreen__media--desktop');
    }

    function queryDOM() {
      hero = document.querySelector('.hero-fullscreen');
      media = hero ? hero.querySelector('.hero-fullscreen__media--desktop') : null;
      overlay = document.querySelector('.hero-zones-overlay');
      zones = overlay ? Array.prototype.slice.call(overlay.querySelectorAll('.hero-zone')) : [];
      transitionEl = document.querySelector('.hero-transition');
      transitionVideoDesktop = transitionEl ? transitionEl.querySelector('.hero-transition__video--desktop') : null;
      transitionVideoMobile = transitionEl ? transitionEl.querySelector('.hero-transition__video--mobile') : null;
    }

    function getNaturalSize(el) {
      if (!el) return null;
      if (el.tagName === 'VIDEO' && el.videoWidth) return { w: el.videoWidth, h: el.videoHeight };
      if (el.tagName === 'IMG' && el.naturalWidth) return { w: el.naturalWidth, h: el.naturalHeight };
      return null;
    }

    function getActiveMediaEl() {
      if (!hero) return null;
      var wrap = mqMobile.matches
        ? hero.querySelector('.hero-fullscreen__media--mobile')
        : hero.querySelector('.hero-fullscreen__media--desktop');
      return wrap ? (wrap.querySelector('video') || wrap.querySelector('img')) : null;
    }

    /*
     * Calcule la position viewport d'un point (px, py) en espace-média [0-1],
     * en compensant object-fit:cover et le scale courant s.
     *
     * object-fit:cover → r = max(W/Mw, H/Mh), centré → offset = (W - Mw*r)/2
     * scale(s) depuis le centre du viewport → xv = W/2 + (xe - W/2) * s
     */
    function positionZones(s) {
      if (!zones.length || !hero) return;
      var mediaEl = getActiveMediaEl();
      var nat = getNaturalSize(mediaEl);
      if (!nat) return;

      var W = hero.offsetWidth;
      var H = hero.offsetHeight;
      var r = Math.max(W / nat.w, H / nat.h);
      var xOff = (W - nat.w * r) / 2;
      var yOff = (H - nat.h * r) / 2;

      // ROM-018 — sur mobile, lire les coords mobile dédiées
      var isMobile = mqMobile.matches;
      zones.forEach(function (zone) {
        var px = parseFloat(isMobile ? zone.dataset.mediaXMobile : zone.dataset.mediaX) / 100;
        var py = parseFloat(isMobile ? zone.dataset.mediaYMobile : zone.dataset.mediaY) / 100;

        var xe = xOff + px * nat.w * r;
        var ye = yOff + py * nat.h * r;

        var xv = W / 2 + (xe - W / 2) * s;
        var yv = H / 2 + (ye - H / 2) * s;

        zone.style.left = (xv / W * 100).toFixed(3) + '%';
        zone.style.top = (yv / H * 100).toFixed(3) + '%';
      });
    }

    /* ROM-010 — scroll scale + opacity : 120%→100% / 100%→50% sur toute la hauteur de page */
    function onScroll() {
      var activeMedia = getActiveMediaWrap();
      if (!activeMedia) return;
      var maxScroll = document.documentElement.scrollHeight - window.innerHeight;
      var progress = maxScroll > 0 ? Math.min(window.scrollY / maxScroll, 1) : 0;
      currentScale = 1.2 - 0.2 * progress;
      var opacity = 1 - 0.5 * progress;
      activeMedia.style.transform = 'scale(' + currentScale.toFixed(4) + ')';
      activeMedia.style.opacity = opacity.toFixed(4);
      if (overlay) overlay.style.opacity = opacity.toFixed(4);
      positionZones(currentScale);
    }

    function enable() {
      onScroll();
      window.addEventListener('scroll', onScroll, { passive: true });
    }

    function disable() {
      window.removeEventListener('scroll', onScroll);
      var activeMedia = getActiveMediaWrap();
      if (activeMedia) { activeMedia.style.transform = ''; activeMedia.style.opacity = ''; }
      if (overlay) overlay.style.opacity = '';
      currentScale = 1.0;
      positionZones(1.0);
    }

    function apply(state) {
      if (state.matches) { enable(); } else { disable(); }
    }

    function bindMediaReady() {
      var el = getActiveMediaEl();
      if (!el) return;
      var onReady = function () { positionZones(currentScale); };
      if (el.tagName === 'VIDEO') {
        if (el.readyState >= 1) { onReady(); }
        else { el.addEventListener('loadedmetadata', onReady, { once: true }); }
      } else {
        if (el.complete) { onReady(); }
        else { el.addEventListener('load', onReady, { once: true }); }
      }
    }

    /* ROM-033 — autoplay vidéo de fond bloqué sur iOS (mode éco d'énergie, ou
       vidéo display:none au load non relancée par WebKit). On ne PEUT PAS forcer
       l'autoplay (restriction Apple). On tente play() ; si rejeté, on masque la
       vidéo pour révéler l'image de preview en dessous (background-media.liquid),
       puis on relance au 1er geste utilisateur (tap/touch). Re-joué au changement
       d'orientation pour la vidéo nouvellement visible. */
    var bgGestureBound = false;

    function getActiveBgVideo() {
      var el = getActiveMediaEl();
      return el && el.tagName === 'VIDEO' ? el : null;
    }

    function bindBgPlayGesture() {
      if (bgGestureBound) return;
      bgGestureBound = true;
      var onGesture = function () {
        document.removeEventListener('pointerdown', onGesture);
        document.removeEventListener('touchstart', onGesture);
        bgGestureBound = false;
        var video = getActiveBgVideo();
        if (!video) return;
        var p = video.play();
        if (p && p.then) { p.then(function () { video.style.opacity = ''; }).catch(function () {}); }
      };
      document.addEventListener('pointerdown', onGesture, { passive: true });
      document.addEventListener('touchstart', onGesture, { passive: true });
    }

    function ensureBgVideoPlays() {
      var video = getActiveBgVideo();
      if (!video) return;
      // Pause l'autre vidéo (masquée par la media query) — pas deux flux décodés.
      if (hero) {
        hero.querySelectorAll('.video-background video').forEach(function (v) {
          if (v !== video) { v.pause(); }
        });
      }
      // Révèle la vidéo dès qu'elle démarre réellement (idempotent par vidéo).
      if (!video.dataset.bgPlayingBound) {
        video.dataset.bgPlayingBound = '1';
        video.addEventListener('playing', function () { video.style.opacity = ''; });
      }
      var p = video.play();
      if (p && p.catch) {
        p.then(function () {
          video.style.opacity = '';
        }).catch(function () {
          // Autoplay refusé (Low Power Mode…) → preview visible, lecture au 1er tap.
          video.style.opacity = '0';
          bindBgPlayGesture();
        });
      }
    }

    /* Rotation aléatoire des dots — durée entre 3s et 9s, sens random */
    function initDotSpins() {
      if (!overlay) return;
      overlay.querySelectorAll('.hero-zone__dot-inner').forEach(function (dot) {
        var duration = (Math.random() * 6 + 3).toFixed(2);
        var direction = Math.random() > 0.5 ? 'normal' : 'reverse';
        dot.style.setProperty('--dot-spin-duration', duration + 's');
        dot.style.setProperty('--dot-spin-dir', direction);
      });
    }

    function initTransition() {
      if (!transitionEl) return;
      var isTransitioning = false;

      var fadeDuration = 0.4; // secondes

      function getContentSections() {
        return Array.prototype.slice.call(
          document.querySelectorAll('main > .shopify-section')
        ).filter(function (s) { return !s.querySelector('.hero-fullscreen'); });
      }

      function cleanupTransition(sections) {
        isTransitioning = false;
        transitionEl.style.transition = '';
        transitionEl.style.opacity = '';
        transitionEl.style.transform = '';
        transitionEl.classList.remove('is-active');
        if (sections) {
          sections.forEach(function (s) { s.style.transition = ''; s.style.opacity = ''; });
        }
        if (overlay) { overlay.style.transition = ''; overlay.style.opacity = ''; }
        var footerEl = document.querySelector('footer');
        if (footerEl) { footerEl.style.transition = ''; footerEl.style.opacity = ''; }
        // ROM-014 — reset nav (cleanup bfcache + erreur transition vidéo)
        var headerComponentEl = document.getElementById('header-component');
        if (headerComponentEl) { headerComponentEl.style.transition = ''; headerComponentEl.style.opacity = ''; }
        hero.querySelectorAll('.hero-fullscreen__gradient').forEach(function (g) {
          g.style.transition = ''; g.style.opacity = '';
        });
      }

      window.addEventListener('pageshow', function (e) {
        if (e.persisted && transitionEl) {
          cleanupTransition(getContentSections());
        }
      });

      var productLinks = Array.prototype.slice.call(document.querySelectorAll('a[ref="cardGalleryLink"], a[ref="productTitleLink"]'));
      productLinks.forEach(function (zone) {
        var href = zone.getAttribute('href');
        if (!href) return;
        if (zone.getAttribute('target') === '_blank') return;

        zone.addEventListener('click', function (e) {
          if (isTransitioning) return;
          var tv = mqMobile.matches ? transitionVideoMobile : transitionVideoDesktop;
          if (!tv) return;

          e.preventDefault();
          isTransitioning = true;

          // Hériter le scale courant du hero
          var activeMedia = getActiveMediaWrap();
          if (activeMedia) {
            transitionEl.style.transform = activeMedia.style.transform || ('scale(' + currentScale.toFixed(4) + ')');
          }
          var targetOpacity = '1';

          // Fade-in + dézoom 2s de la vidéo de transition
          transitionEl.style.opacity = '0';
          transitionEl.style.transition = 'opacity ' + fadeDuration + 's ease, transform 3s ease';
          transitionEl.classList.add('is-active');
          transitionEl.offsetHeight; // force reflow
          transitionEl.style.opacity = targetOpacity;
          transitionEl.style.transform = 'scale(1)';

          // Fade-out des sections produits + zones hero
          var contentSections = getContentSections();
          contentSections.forEach(function (s) {
            s.style.transition = 'opacity ' + fadeDuration + 's ease';
            s.style.opacity = '0';
          });
          if (overlay) {
            overlay.style.transition = 'opacity ' + fadeDuration + 's ease';
            overlay.style.opacity = '0';
          }
          var footerEl = document.querySelector('footer');
          if (footerEl) {
            footerEl.style.transition = 'opacity ' + fadeDuration + 's ease';
            footerEl.style.opacity = '0';
          }
          // ROM-014 — fade-out nav pendant la transition produit
          // #header-group est en display:contents quand sticky header activé
          // (header.liquid L551), donc opacity dessus est inerte → on cible
          // directement #header-component qui a sa box rendue.
          var headerComponentEl = document.getElementById('header-component');
          if (headerComponentEl) {
            headerComponentEl.style.transition = 'opacity ' + fadeDuration + 's ease';
            headerComponentEl.style.opacity = '0';
          }
          hero.querySelectorAll('.hero-fullscreen__gradient').forEach(function (g) {
            g.style.transition = 'opacity 5s ease';
            g.style.opacity = '0';
          });

          tv.currentTime = 0;

          tv.addEventListener('ended', function () {
            isTransitioning = false;
            window.location.href = href;
          }, { once: true });

          tv.addEventListener('error', function () {
            cleanupTransition(contentSections);
            window.location.href = href;
          }, { once: true });

          var p = tv.play();
          if (p !== undefined) {
            p.catch(function () {
              cleanupTransition(contentSections);
              window.location.href = href;
            });
          }
        });
      });
    }

    // ROM-021 — hero-zones avec anchor same-page : smooth scroll robuste
    // (résout par suffix match si le theme ID change, ex. shopify-section-template--XXX__product_list_YYY)
    function initHeroZoneAnchors() {
      var heroZoneLinks = document.querySelectorAll('a.hero-zone');
      heroZoneLinks.forEach(function (zone) {
        zone.addEventListener('click', function (e) {
          var href = zone.getAttribute('href');
          if (!href) return;
          var u;
          try { u = new URL(href, location.origin); } catch (err) { return; }
          if (u.origin !== location.origin || u.pathname !== location.pathname || !u.hash) return;
          var anchorId = u.hash.substring(1);
          var target = document.getElementById(anchorId);
          if (!target) {
            var keyMatch = anchorId.match(/__(.+)$/);
            if (keyMatch) target = document.querySelector('[id$="__' + keyMatch[1] + '"]');
          }
          if (target) {
            e.preventDefault();
            target.scrollIntoView({ behavior: 'smooth' });
          }
        });
      });
    }

    function init() {
      queryDOM();
      if (!hero || !media) return;
      apply(mq);
      bindMediaReady();
      ensureBgVideoPlays();
      initDotSpins();
      initTransition();
      initHeroZoneAnchors();
    }

    init();
    mq.addEventListener('change', apply);
    mqMobile.addEventListener('change', function () { queryDOM(); bindMediaReady(); ensureBgVideoPlays(); });
    window.addEventListener('resize', function () { positionZones(currentScale); }, { passive: true });

    /* Réinitialise après chaque re-render de la section dans l'éditeur admin */
    document.addEventListener('shopify:section:load', function (e) {
      if (e.target && e.target.querySelector && e.target.querySelector('.hero-fullscreen')) {
        init();
      }
    });

    /* ROM-006 — parallax souris (commenté — ROM-010)
    var maxShift = 6;
    var restScale = 100 / 120;
    var followLerp = 0.012;
    var tweenDuration = 2000;
    var rawX = 0, rawY = 0;
    var smoothX = 0, smoothY = 0;
    var presence = 0;
    var presenceFrom = 0, presenceTo = 0, tweenDur = 1, tweenStart = 0, tweening = false;
    var rafId = null;

    function easeInOut(t) {
      return t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2;
    }
    function render() {
      var scale = restScale + (1 - restScale) * presence;
      var tx = smoothX * presence;
      var ty = smoothY * presence;
      media.style.transform =
        'translate3d(' + tx.toFixed(3) + '%, ' + ty.toFixed(3) + '%, 0) scale(' + scale.toFixed(4) + ')';
    }
    function ensureRaf() { if (!rafId) rafId = requestAnimationFrame(tick); }
    function startTween(to) {
      presenceFrom = presence; presenceTo = to;
      tweenDur = Math.max(tweenDuration * Math.abs(to - presenceFrom), 1);
      tweenStart = 0; tweening = true; ensureRaf();
    }
    function onMove(event) {
      var rect = hero.getBoundingClientRect();
      var nx = ((event.clientX - rect.left) / rect.width) * 2 - 1;
      var ny = ((event.clientY - rect.top) / rect.height) * 2 - 1;
      rawX = -nx * maxShift; rawY = -ny * maxShift; ensureRaf();
    }
    function onEnter() { startTween(1); }
    function onLeave() { startTween(0); }
    function tick(now) {
      if (tweening) {
        if (!tweenStart) tweenStart = now;
        var t = Math.min((now - tweenStart) / tweenDur, 1);
        presence = presenceFrom + (presenceTo - presenceFrom) * easeInOut(t);
        if (t >= 1) { presence = presenceTo; tweening = false; }
      }
      smoothX += (rawX - smoothX) * followLerp;
      smoothY += (rawY - smoothY) * followLerp;
      render();
      var settled = !tweening && Math.abs(rawX - smoothX) < 0.01 && Math.abs(rawY - smoothY) < 0.01;
      rafId = settled ? null : requestAnimationFrame(tick);
    }
    function enableParallax() {
      presence = 0; tweening = false; rawX = 0; rawY = 0; smoothX = 0; smoothY = 0;
      render();
      hero.addEventListener('mousemove', onMove);
      hero.addEventListener('mouseenter', onEnter);
      hero.addEventListener('mouseleave', onLeave);
    }
    function disableParallax() {
      hero.removeEventListener('mousemove', onMove);
      hero.removeEventListener('mouseenter', onEnter);
      hero.removeEventListener('mouseleave', onLeave);
      if (rafId) { cancelAnimationFrame(rafId); rafId = null; }
      tweening = false; media.style.transform = '';
    }
    */
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
